import { useEffect, useState } from 'react'
import { useSnackBar } from '../../../contexts/snackbar.context'
import { HttpErrorType } from '../../../types/http.type'
import { errorColor, errorMessage } from 'utils/error.util'
import creaService from 'services/crea.service'
import { CreasResponse } from 'types/creas.type'

export const useCreasUsuario = () => {
  const { showSnackBar } = useSnackBar()
  const [creas, setCreas] = useState<CreasResponse[]>([])

  useEffect(() => {
    ;(async () => {
      await creaService
        .getCreasByUser()
        .then((response) => {
          if (response.data && response.data) {
            setCreas(response.data)
          }
        })
        .catch((error: HttpErrorType) => {
          showSnackBar(errorMessage(error), errorColor(error))
        })
    })()
  }, [])

  return {
    creas,
  }
}
